import { render, staticRenderFns } from "./view-event-dialog.vue?vue&type=template&id=1edc1cb8&scoped=true"
import script from "./view-event-dialog.vue?vue&type=script&lang=js"
export * from "./view-event-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-event-dialog.vue?vue&type=style&index=0&id=1edc1cb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc1cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1edc1cb8')) {
      api.createRecord('1edc1cb8', component.options)
    } else {
      api.reload('1edc1cb8', component.options)
    }
    module.hot.accept("./view-event-dialog.vue?vue&type=template&id=1edc1cb8&scoped=true", function () {
      api.rerender('1edc1cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/view-event-dialog.vue"
export default component.exports